export class GermanUfEquationWindow {
  systemName: string;
  glazingInsulationType: string | null;
  fixedorOperable: string | null;
  glassThickness: number | null;
  papt: string | null;
  ventFWidth: number | null;
  k: number | null;
  l: number | null;

  constructor(row: Record<string, string | number | null>) {
    this.systemName = row['systemName'] as string;
    this.glazingInsulationType = row['glazingInsulationType'] as string | null;
    this.fixedorOperable = row['fixedorOperable'] as string | null;
    this.glassThickness = row['glassThickness'] as number | null;
    this.papt = row['papt'] as string | null;
    this.ventFWidth = row['ventFWidth'] as number | null;
    this.k = row['k'] as number | null;
    this.l = row['l'] as number | null;
  }
}